/** Refine DataProvider — REST → FastAPI через axios. */

import type { DataProvider } from "@refinedev/core";

import { api } from "@/lib/api";

const apiUrl = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");

export const dataProvider: DataProvider = {
  getApiUrl: () => apiUrl,

  async getList({ resource, pagination, filters, sorters }) {
    const page = pagination?.current ?? 1;
    const per_page = pagination?.pageSize ?? 25;

    const params: Record<string, unknown> = { page, per_page };

    // Sorters
    const s = sorters?.[0];
    if (s) {
      params.sort = `${s.field}_${s.order}`;
    }

    // Filters
    if (filters) {
      for (const f of filters) {
        if ("field" in f && f.value !== undefined && f.value !== "") {
          params[f.field] = f.value;
        }
      }
    }

    const { data } = await api.get(`/${resource}`, { params });
    return {
      data: data.data ?? data,
      total: data.pagination?.total ?? data.total ?? (data.data ?? data).length,
    };
  },

  async getOne({ resource, id }) {
    const { data } = await api.get(`/${resource}/${id}`);
    return { data };
  },

  async create({ resource, variables }) {
    const { data } = await api.post(`/${resource}`, variables);
    return { data };
  },

  async update({ resource, id, variables }) {
    const { data } = await api.patch(`/${resource}/${id}`, variables);
    return { data };
  },

  async deleteOne({ resource, id }) {
    const { data } = await api.delete(`/${resource}/${id}`);
    return { data };
  },

  async custom({ url, method, payload, query, headers }) {
    const config = { params: query, headers };
    let data;
    switch (method) {
      case "post":
        ({ data } = await api.post(url, payload, config));
        break;
      case "put":
        ({ data } = await api.put(url, payload, config));
        break;
      case "patch":
        ({ data } = await api.patch(url, payload, config));
        break;
      case "delete":
        ({ data } = await api.delete(url, config));
        break;
      default:
        ({ data } = await api.get(url, config));
    }
    return { data };
  },

  async getMany({ resource, ids }) {
    // Backend пока не имеет batch endpoint — fallback на parallel getOne
    const results = await Promise.all(
      ids.map((id) => api.get(`/${resource}/${id}`).then((r) => r.data)),
    );
    return { data: results };
  },
};
